import jwtDecode from 'jwt-decode'
import {
  checkingUserAuthPerPage,
  getItemStorage,
  removeItemStorage,
  setItemStorage
} from '../plugins/util'
import { profile } from '@/store/api/user'
import { get } from '@/plugins/lodash'
import { getPartnerFromToken } from '../utils/order'

export const globalMethods = {
  $_globalMixin_requestErrorHandle(res) {
    return new Promise(
      function (resolve, reject) {
        if (!res) {
          reject(res)
        }

        const resData = res.data || res.error
        if (!resData) {
          reject(res)
        }

        switch (res.status) {
          case 400: {
            let msg = res.data.description || res.data.title
            if (msg) {
              this.showMessage(msg)
            }
            resolve()
            break
          }
          case 401: {
            if (
              (this.$constants &&
                this.$constants.ERROR_CODES &&
                resData.code === this.$constants.ERROR_CODES.NOT_AUTHORIZED.code) ||
              resData.code === 'NOT_AUTHORIZED'
            ) {
              this.showTokenExpiredDialog()
              resolve()
            } else {
              let msg = resData.description || resData.title
              if (msg) {
                this.showMessage(msg)
              }
            }
            break
          }
          case 404:
            if (
              (this.$constants &&
                this.$constants.ERROR_CODES &&
                resData.code === this.$constants.ERROR_CODES.TOKEN_NOT_FOUND.code) ||
              resData.code === 'TOKEN_NOT_FOUND'
              // && this.$route.name !== 'index'
            ) {
              this.showTokenExpiredDialog()
              resolve()
            } else {
              const msg = resData.description || resData.title
              if (msg) {
                this.showMessage(msg)
              }
            }
            break
          case 408: {
            let msg = this.$t('error_message.request_timeout')
            this.showMessage(msg)
            break
          }
          case 500:
            if (
              resData.description &&
              resData.description.indexOf('is not a valid ObjectId') > -1
            ) {
              console.log('500')
            } else {
              this.showMaintenanceMessage()
              reject(res)
            }
            break
          case 502:
            this.showMaintenanceMessage()
            reject(res)
            break
          case 503:
            this.showMaintenanceMessage()
            break
          default: {
            const description = resData.description
            const title = resData.title
            const msg = description || title
            if (msg) {
              this.showMessage(msg)
            }
            reject(res)
          }
        }
      }.bind(this)
    )
  },
  showMaintenanceMessage() {
    const message = this.$t('system_under_maintenance')
    this.showMessage(message, 10000)
  },
  showTokenExpiredDialog() {
    if (!(this.$store && this.$store.getters && this.$store.getters.showTokenExpiredDialog)) {
      this.resetUserProfile()
      this.$store.dispatch('setShowTokenExpireModal', true)
    }
  },
  resetUserProfile() {
    this.$cookie.delete(this.$constants.COOKIE_NAME__TOKEN)
    this.$cookie.delete(this.$constants.COOKIE_NAME__TOKEN, {
      domain: this.$_VUE_APP_DOMAIN
      // process.env.VUE_APP_DOMAIN
    })
    this.$store.dispatch('signOut')
    removeItemStorage(this.$constants.LOCAL_STORAGE_KEY__USER)
    removeItemStorage(this.$constants.LOCAL_STORAGE_KEY__PARTNER_GET_FROM_TOKEN)

    if (this.$analyticTracking && this.$trackingEvents) {
      this.$analyticTracking.logEvent(
        this.$trackingEvents.ACTIONS.NON_INTERACTION,
        this.$trackingEvents.EVENTS.LOGOUT_SUCCESS,
        {}
      )
    }
  },
  showMessage(msg, timeout, color = 'error') {
    const payload = {
      visible: true,
      color,
      timeout: timeout || 3000,
      title: msg
    }
    this.$store.dispatch('setSnackbar', payload)
  },
  $_globalMixin_onShowDialog() {
    var html = document.documentElement
    let className = html.className
    className += ' is-clipped'
    html.className = className.trim()
  },
  $_globalMixin_onHideDialog() {
    var html = document.documentElement
    let className = html.className
    className = className.replace('is-clipped', '')
    html.className = className.trim()
  },
  updateUserProfile(profile) {
    checkingUserAuthPerPage(this.$_PAGE, profile).then((isAuth) => {
      if (!isAuth) {
        this.$cookie.delete(this.$constants.COOKIE_NAME__TOKEN)
        this.$cookie.delete(this.$constants.COOKIE_NAME__TOKEN, {
          domain: process.env.VUE_APP_DOMAIN
        })

        this.$store.dispatch('signOut')
        removeItemStorage(this.$constants.LOCAL_STORAGE_KEY__USER)

        this.$router.push({ name: 'sign-in' })
        this.showMessage(this.$t('not_authorized'), 5000)

        return
      }

      setItemStorage(this.$constants.LOCAL_STORAGE_KEY__USER, JSON.stringify(profile))
      this.$store.dispatch('setUserProfile', profile)

      getPartnerFromToken(this)

      this.$store.dispatch('setLocale', profile.language)
      this.$i18n.i18next.changeLanguage(profile.language)
      this.$vuetify.lang.current = profile.language
      window.dataLayer.push({
        user_language: profile.language
      })
      this.$analyticTracking.logIdentify(profile)
      this.$forceUpdate()

      if (!profile.extra || !profile.extra.order_tags) {
        this.$store.dispatch('createOrderTag', this.$constants.DEFAULT_ORDER_TAGS)
      }

      if (profile.partner) {
        if (window.getKAProfileTimeout) {
          clearTimeout(window.getKAProfileTimeout)
        }
        window.getKAProfileTimeout = setTimeout(() => {
          this.$_globalMixin_getKAProfile()
        }, 20)
      }
    })
  },
  async $_globalMixin_updateUserProfile() {
    const decodedToken = jwtDecode(this.$store.getters.token)
    console.log('decodedToken', decodedToken)

    let newProfile = null

    try {
      if (decodedToken && decodedToken.typ === 'supplier') {
        // case: Supplier
        const response = await this.axios.get(
          `${process.env.VUE_APP_API_URL}${this.$constants.API.supplier.profile}?token=${this.$store.getters.token}`
        )
        newProfile = response.data
      } else {
        // case: User
        const response = await profile()
        newProfile = response.data
      }
    } catch (error) {
      this.$_globalMixin_requestErrorHandle(error.response)
    }

    if (newProfile) {
      this.updateUserProfile(newProfile)
    }
  },
  $_globalMixin_loadOrdersList(params) {
    return new Promise((resolve, reject) => {
      const api = process.env.VUE_APP_API_URL.concat(this.$constants.API.order.list)
      this.axios(api, { params: params })
        .then((response) => {
          if (response && response.data) {
            resolve(response.data)
          } else {
            reject()
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  $_globalMixin_dowloadFile(data, fileName) {
    const blob = new Blob(['\ufeff' + data], {
      type: 'application/octet-stream'
    })

    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, fileName)
    } else {
      var link = document.createElement('a')
      if (link.download !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute
        var url = URL.createObjectURL(blob)
        link.setAttribute('href', url)
        link.setAttribute('download', fileName)
        link.style = 'visibility:hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    }
  },
  $_globalMixin_getKAProfile(callback) {
    const profile = this.$store.getters.userProfile
    const token = this.$store.getters.token
    if (!token || !profile || !profile.partner || profile.partner === 'ahamove') return

    this.$store
      .dispatch('getKeyAccountProfile')
      .then((response) => {
        const ka_profile = response && response.ka_profile
        if (ka_profile) {
          const profile = Object.assign({}, this.$store.getters.userProfile, {
            ka_profile
          })
          setItemStorage(this.$constants.LOCAL_STORAGE_KEY__USER, JSON.stringify(profile))
          this.$store.dispatch('setUserProfile', profile)
          this.$forceUpdate()
          if (callback) callback()
        }
      })
      .catch((error) => {
        console.log('$_globalMixin_getKAProfile error', error)
        if (callback) callback()
        // this.$_globalMixin_requestErrorHandle(error.response)
      })
    // this.$store.dispatch('getPartnerProfile')
  },
  // ponytail: clone of $_globalMixin_getKAProfile — stale-while-revalidate for SGC.
  //   Rehydrate ka_profile from localStorage if Vuex chưa có (state.profile khởi tạo undefined),
  //   resolve ngay nếu đã có cache, đồng thời fetch nền để refresh.
  $_globalMixin_getKAProfileAsync() {
    let profile = this.$store.getters.userProfile
    const token = this.$store.getters.token
    if (!token) return Promise.resolve()

    if (!profile) {
      const cached = getItemStorage(this.$constants.LOCAL_STORAGE_KEY__USER)
      if (cached) {
        try {
          profile = typeof cached === 'string' ? JSON.parse(cached) : cached
          this.$store.dispatch('setUserProfile', profile)
        } catch (e) {
          profile = null
        }
      }
    }

    if (!profile || !profile.partner || profile.partner === 'ahamove') return Promise.resolve()

    const fetchPromise = this.$store
      .dispatch('getKeyAccountProfile')
      .then((response) => {
        const ka_profile = response && response.ka_profile
        if (ka_profile) {
          const newProfile = Object.assign({}, this.$store.getters.userProfile, { ka_profile })
          setItemStorage(this.$constants.LOCAL_STORAGE_KEY__USER, JSON.stringify(newProfile))
          this.$store.dispatch('setUserProfile', newProfile)
        }
      })
      .catch((error) => {
        console.log('$_globalMixin_getKAProfileAsync error', error)
      })

    return profile.ka_profile ? Promise.resolve() : fetchPromise
  },
  $_globalMixin_opsTech_checkPaymentStatus() {
    let paymentSettings = get(this.$store.getters.kaProfile, 'payment_settings', null)
    if (!paymentSettings) return null
    let today = this.$moment().utcOffset(7).startOf('day').unix()
    let isActive = get(paymentSettings, 'contract_status', 'inactive') === 'active'
    let paymentDeadline = get(paymentSettings, 'payment_deadline', today)
    if (isActive && paymentDeadline >= today) return null
    return paymentDeadline
  }
}

export const globalComputed = {
  isMobile() {
    // console.log('this.$mobileDetect', this.$mobileDetect)
    const screenWidth = (screen && screen.width) || 768
    return (
      this.$mobileDetect &&
      this.$mobileDetect.mobile() &&
      !this.$mobileDetect.tablet() &&
      screenWidth <= 768
    )
  }
}
